import { PlateLeaf } from "@platejs/core/react";
import { withRef } from "@udecode/cn";
import { clsx } from "clsx";

export const CodeSyntaxLeaf = withRef<typeof PlateLeaf>(
	({ children, className, ...props }, ref) => {
		const tokenClassName = props.leaf.className as string;

		return (
			<PlateLeaf
				ref={ref}
				{...props}
				className={clsx(tokenClassName, className)}
			>
				{children}
			</PlateLeaf>
		);
	}
);
